import axios from 'axios'
import { ENVIRONMENT, SESSION_KEY } from 'common/config'
import Cookies from 'js-cookie'
import queryString from 'query-string'
import { ApiClient } from 'services/ApiService'

const dkkd = 'dkkd/'

interface GetListDKKDPayload {
  search: string
  page: number
  mst: string
  date: Record<'from' | 'to', string>
  dateFounding: Record<'fromFoundingDate' | 'toFoundingDate', string>
  query: Record<string, string>
  isActive: number
  phone: number
}

const buildDKKDParams = (
  payload: GetListDKKDPayload,
  extra?: Record<string, any>
) => {
  const params: Record<string, any> = {
    page: payload.page,
    search: payload.search.trim(),
    mst: payload.mst.trim(),
    fromDate: payload.date.from,
    toDate: payload.date.to,
    query: payload.query,
    is_active: payload.isActive,
    phone: payload.phone ? 1 : 0,
    ...extra,
  }

  if (
    payload.dateFounding.fromFoundingDate &&
    payload.dateFounding.toFoundingDate
  ) {
    params.fromFoundingDate = payload.dateFounding.fromFoundingDate
    params.toFoundingDate = payload.dateFounding.toFoundingDate
  }

  return params
}

export const getListDKKD = (payload: GetListDKKDPayload) => {
  return ApiClient.get(`${dkkd}customer`, buildDKKDParams(payload))
}

export const getNghanhNgheChinh = (search: string) => {
  return ApiClient.get(`${dkkd}tenNganhNgheChinh?search=${search}`)
}
export const getLoaiKhoan = (search: string) => {
  return ApiClient.get(`${dkkd}loaiKhoan?search=${search}`)
}
export const getLinhVucKinhTe = (search: string) => {
  return ApiClient.get(`${dkkd}linhVucKinhTe?search=${search}`)
}

export const addAllListDKKDToGroup = (payload: Record<string, any>) => {
  return ApiClient.post(`${dkkd}transferAllDKKD`, payload)
}

const BASE_URL_DEV = ENVIRONMENT.BASE_URL

//export excel file - limit customer
export const handleExportExcelDKKD = (
  payload: GetListDKKDPayload,
  params?: any
) => {
  const url = queryString.stringifyUrl({
    url: `${BASE_URL_DEV}${dkkd}exportExcel`,
    query: buildDKKDParams(payload, params),
  })

  return axios.get(url, {
    responseType: 'blob',
    headers: { 'Content-Type': null, token: Cookies.get(SESSION_KEY.SESSION) },
  })
}

//export excel file - full customer
// export const handleExportExcelDKKD = (payload: GetListDKKDPayload) => {
//   return ApiClient.get(
//     `${dkkd}exportCustomerUseBull?page=${
//       payload.page
//     }&search=${payload.search.trim()}&mst=${payload.mst.trim()}&fromDate=${
//       payload.date.from
//     }&toDate=${payload.date.to}&query=${payload.query}&is_active=${
//       payload.isActive
//     }&phone=${payload.phone ? 1 : 0}`
//   )
// }
